module.exports = __webpack_public_path__ + "img/img11.1fe238a5.png";